import * as React from 'react'

export interface OptionRowProps {
  label: string
  description?: string
  control: React.ReactNode
}

export function OptionRow({ label, description, control }: OptionRowProps) {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="min-w-0">
        <div className="text-sm font-semibold text-primary">{label}</div>
        {description ? <div className="text-xs text-muted">{description}</div> : null}
      </div>
      <div className="flex items-center gap-2 shrink-0">{control}</div>
    </div>
  )
}

